export const GENERIC_TOASTS = {
  DELETED: '#{resource} successfully deleted',
  UPLOADED: '#{resource} successfully uploaded',
  UPDATED: '#{resource} successfully updated',
  CREATED: '{resource} successfully created',

  DELETE_DENIED: 'You do not have permission to delete this #{lowerCase}',
};
